import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiEye,
  FiAlertCircle,
  FiMail,
  FiCalendar,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function SIPMonitor() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("bounced");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [sips] = useState([
    {
      id: 1,
      sipId: "SIP-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      schemeName: "HDFC Equity Fund",
      amount: 5000,
      frequency: "Monthly",
      nextDebitDate: "2024-02-01",
      status: "Bounced",
      bounceReason: "Insufficient funds",
      retryCount: 2,
      mandateId: "MND-001",
    },
    {
      id: 2,
      sipId: "SIP-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      schemeName: "ICICI Balanced Fund",
      amount: 3000,
      frequency: "Monthly",
      nextDebitDate: "2024-02-05",
      status: "Active",
      bounceReason: null,
      retryCount: 0,
      mandateId: "MND-002",
    },
    {
      id: 3,
      sipId: "SIP-003",
      userId: "USR-003",
      userName: "Amit Patel",
      schemeName: "SBI Debt Fund",
      amount: 10000,
      frequency: "Monthly",
      nextDebitDate: "2024-02-10",
      status: "Bounced",
      bounceReason: "Bank account closed",
      retryCount: 1,
      mandateId: "MND-003",
    },
  ]);

  const handleResync = (sipId) => {
    Swal.fire({
      title: "Resync SIP?",
      text: "This will trigger a resync with the partner system.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resync",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Resync Started!", "SIP resync process initiated.", "success");
      }
    });
  };

  const handleRetry = (sipId) => {
    Swal.fire({
      title: "Retry SIP Debit?",
      text: "This will retry the failed SIP debit.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Retry",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Retry Initiated!", "SIP debit retry process started.", "success");
      }
    });
  };

  const handleInformClient = (sipId, userName) => {
    Swal.fire({
      title: "Inform Client",
      text: `Send notification to ${userName} about SIP status?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Send Notification",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Notification Sent!", "Client has been informed.", "success");
      }
    });
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredSIPs = sips.filter((sip) => {
    const matchesSearch =
      sip.sipId.includes(searchTerm) ||
      sip.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      sip.schemeName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || sip.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSIPs.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredSIPs.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="content-page-header content-page-headersplit">
                <h5>SIP Monitor</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/mutual-funds/sip-monitor">Mutual Funds</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    SIP Monitor
                  </li>
                </ol>
              </nav>

            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Filters */}
                <div className="row g-2 flex-grow-1">
                  {/* Search */}
                  <div className="col-12 col-md-6">
                    <div className="position-relative">
                      <FiSearch
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#64748b",
                          zIndex: 1,
                        }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by SIP ID, user name, or scheme..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setCurrentPage(0);
                        }}
                        style={{ paddingLeft: "40px" }}
                      />
                    </div>
                  </div>

                  {/* Status Filter */}
                  <div className="col-12 col-md-3">
                    <select
                      className="form-control"
                      value={statusFilter}
                      onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                    >
                      <option value="all">All Status</option>
                      <option value="Active">Active</option>
                      <option value="Bounced">Bounced</option>
                      <option value="Paused">Paused</option>
                    </select>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button className="btn btn-primary">
                    Export
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>SIP ID</th>
                          <th>User</th>
                          <th>Scheme</th>
                          <th>Amount</th>
                          <th>Frequency</th>
                          <th>Next Debit</th>
                          <th>Status</th>
                          <th>Bounce Reason</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((sip) => (
                            <tr key={sip.id}>
                              <td style={{ fontWeight: "500" }}>{sip.sipId}</td>
                              <td style={{ fontWeight: "500" }}>{sip.userName}</td>
                              <td>{sip.schemeName}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(sip.amount)}</td>
                              <td>{sip.frequency}</td>
                              <td>{sip.nextDebitDate}</td>
                              <td>
                                <span className={sip.status === "Active" ? "badge-active" : sip.status === "Bounced" ? "badge-pending" : "badge-pending"}>
                                  {sip.status}
                                </span>
                              </td>
                              <td>{sip.bounceReason || "-"}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    title="View Details"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  {sip.status === "Bounced" && (
                                    <>
                                      <div
                                        className="delete-table me-2"
                                        onClick={() => handleResync(sip.sipId)}
                                        title="Resync SIP"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-redo"></i>
                                      </div>
                                      <div
                                        className="delete-table me-2"
                                        onClick={() => handleRetry(sip.sipId)}
                                        title="Retry Debit"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-redo"></i>
                                      </div>
                                    </>
                                  )}
                                  <div
                                    className="delete-table"
                                    onClick={() => handleInformClient(sip.sipId, sip.userName)}
                                    title="Inform Client"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-envelope"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
